<template>
  <div>
    <div v-if="missonList.length !== 0" class="missions-area">
      <List :missonList="missonList" @click-mission="onClick" />
    </div>
    <div v-if="selectedMission">
      {{ selectedMission.mission_title }}
      <InfoModal
        v-if="status === 'info'"
        :selectedMission="selectedMission"
        :distance="distance"
        @click-try="onCickTry"
        @click-close="onClickCloseInfo"
      />
      <QuizListModal
        v-if="status === 'quizlist'"
        :selectedMission="selectedMission"
        :distance="distance"
        @click-try="onCickTry"
        @click-close="onClickCloseQuizList"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitleArea from "@/components/Atoms/TitleArea";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import Info from "@/components/QuizMission/Info";
import List from "@/components/QuizMission/List";
import InfoModal from "@/components/QuizMission/InfoModal";
import QuizListModal from "@/components/QuizMission/QuizListModal";

export default {
  name: "show-mission-area",
  components: {
    TitleArea,
    ButtonTextLink,
    Info,
    List,
    InfoModal,
    QuizListModal,
  },
  props: {
    missonList: { type: Array, require: true },
    distance: { type: Number, require: true },
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState(["missions"]),
    displayDistance() {
      const n = 1;
      return Math.round(this.distance * Math.pow(10, n)) / Math.pow(10, n);
    },
  },
  data() {
    return {
      selectedMission: undefined,
      // info -> quizlist
      status: "info",
      expandQuizList: [0],
      answers: [],
    };
  },
  methods: {
    onClick(mission) {
      this.selectedMission = mission;
    },
    onClickCloseInfo() {
      this.selectedMission = undefined;
    },
    onClickCloseQuizList() {
      this.status = "info";
    },
    onClickQuiz(index) {
      this.expandQuizList.filter((item) => item === index).length === 0
        ? this.expandQuizList.push(index)
        : this.expandQuizList.splice(this.expandQuizList.indexOf(index), 1);
    },
    onCickTry() {
      this.status = "quizlist";
    },
    onClickOption(index, optionIndex, correct) {
      this.$set(this.answers, index, { optionIndex, correct });
    },
    onCickRetry() {
      this.status = "quizlist";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.missions-area {
  margin: 2rem 0;
  padding: 0 1.25rem;
}

hr {
  border: none;
  background: #ddd;
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelectModal/QuizMissionArea.vue